import { createElement } from 'react';
import { string, node } from 'prop-types';
import 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
import { b as _objectWithoutPropertiesLoose, c as _extends, a as _objectSpread } from '../chunk-ad6ad343.js';
import 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import '../Icon/styled.js';
import '../Pane/styled.js';
import { b as panePropTypes, c as paneDefaultProps } from '../chunk-895bf8c9.js';
import '../Pane/index.js';
import '../Text/styled.js';
import '../Text/index.js';
import Card from './styled.js';

var CardCard = function CardCard(_ref) {
  var a11yDescriptionId = _ref.a11yDescriptionId,
      a11yTitleId = _ref.a11yTitleId,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["a11yDescriptionId", "a11yTitleId", "children"]);

  return createElement(Card, _extends({
    "aria-describedby": a11yDescriptionId,
    "aria-labelledby": a11yTitleId
  }, props), children);
};

var cardCardPropTypes = _objectSpread({
  a11yDescriptionId: string,
  a11yTitleId: string,
  children: node.isRequired,
  className: string
}, panePropTypes);

CardCard.propTypes = cardCardPropTypes;

var cardCardDefaultProps = _objectSpread({}, paneDefaultProps, {
  a11yDescriptionId: undefined,
  a11yTitleId: undefined,
  border: 'shadow',
  children: undefined,
  className: undefined
});

CardCard.defaultProps = cardCardDefaultProps;
var C = CardCard;
export default C;
export { CardCard, cardCardDefaultProps, cardCardPropTypes };